import { render, staticRenderFns } from "./manutencao.vue?vue&type=template&id=1172e9c8&scoped=true&"
import script from "./manutencao.vue?vue&type=script&lang=js&"
export * from "./manutencao.vue?vue&type=script&lang=js&"
import style0 from "./manutencao.vue?vue&type=style&index=0&id=1172e9c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172e9c8",
  null
  
)

export default component.exports